/**
 * Enum for the possible contact preference options.
 */
export const CONTACT_PREFERENCES = {
    "contact_by_phone": "Call Me",
    "contact_by_text": "Text Me",
    "contact_by_email": "Email Me",
}
